import { useState } from "react";
import { Languages, Loader2, ChevronDown, ChevronUp } from "lucide-react";

interface TranslateButtonProps {
  text: string;
}

export function TranslateButton({ text }: TranslateButtonProps) {
  const [translated, setTranslated] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  async function handleTranslate() {
    if (translated) {
      setExpanded(!expanded);
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("http://localhost:8765/api/translate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text, target_lang: "auto" }),
      });
      const data = await res.json();
      if (data.success) {
        setTranslated(data.translation);
        setExpanded(true);
      }
    } catch {
      // Translation failed silently
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mt-1">
      <button
        onClick={handleTranslate}
        disabled={loading || !text.trim()}
        className="inline-flex items-center gap-1 text-[11px] text-slate-500 hover:text-cyan-400 transition-colors disabled:opacity-40"
      >
        {loading ? (
          <Loader2 className="w-3 h-3 animate-spin" />
        ) : translated ? (
          expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />
        ) : (
          <Languages className="w-3 h-3" />
        )}
        <span>{loading ? "翻译中..." : translated ? (expanded ? "收起翻译" : "查看翻译") : "翻译"}</span>
      </button>
      {expanded && translated && (
        <div className="mt-1 px-3 py-2 rounded-lg bg-slate-700/50 border border-slate-600/50 text-xs text-cyan-300/90 leading-relaxed whitespace-pre-wrap break-words">
          {translated}
        </div>
      )}
    </div>
  );
}
